import { BaseeSearchClass, ReturnClass } from 'projects/Shared-Lib/model/search-result';
import { SelectListItem } from '../lib/select/select-property';
import * as t from '../lib/select/select-service';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { Router } from '@angular/router';
import { DataService } from 'projects/Shared-Lib/services/data.service';

const ControllerName = 'AuthUserApps';

export class AuthUserApps {
  UserID?: string;
  UserAccount?: string;
  ApplicationID?: string;
  IsEnabled?: boolean;
  UpdatedDateTime?: string;
  UpdatedBy?: string;
  SelectEnabled?: any;
  SelectedAuthUser?: any;

  SetData(data: AuthUserApps) {
    this.UserID = data.UserID;
    this.UserAccount = data.UserAccount;
    this.ApplicationID = data.ApplicationID;
    this.IsEnabled = data.IsEnabled;
    this.UpdatedDateTime = data.UpdatedDateTime;
    this.UpdatedBy = data.UpdatedBy;
    this.SelectEnabled = data.IsEnabled ? 1 : 0;
    this.SelectedAuthUser = data.UserAccount;
  }
}

export class SearchClass extends BaseeSearchClass {
  UserAccount?: string;
  ApplicationID?: string;
  IsEnabled?: string;
}

export class AuthUserApps_Search {
  filter: SearchClass;
  ddlIsEnabled?: SelectListItem[];
  selectedEnabled?: SelectListItem;
  DataResult?: ReturnClass;

  constructor() {
    this.filter = new SearchClass();
    this.filter.ApplicationID = '';
    this.filter.IsEnabled = '';

    this.ddlIsEnabled = t.GetItems(t.Items.Options_Enabled, true);
    this.DataResult = { draw: 1, recordsFiltered: 0, recordsTotal: 0, data: [] };
  }
}

export class AuthUserApps_Document extends AuthUserApps{
  ddlIsEnabled?: any;
  SelectEnabled?: any;
  ddlAuthApplication?: SelectListItem[];

  constructor(private _dlgService: DialogService, private router: Router, private dataService: DataService) {
    super();
    this.ddlIsEnabled = t.GetItems(t.Items.Options_Enabled);
  }
  
  /** Get Document by ApplicationID
  * @param userid : string
  */
  GetDocument(userid: string) {
    this.dataService.getData(`${ControllerName}/${userid}`, null, (ret) => {
      this.SetData(ret);
    }, (ret) =>{
      this._dlgService.ErrorInformation(ret.Message);
    });
  }
}